import React from 'react';
import {
  Box,
  VStack,
  Text,
  Icon
} from '@chakra-ui/react';
import { FiUpload } from 'react-icons/fi';
import { ContentRequirement } from '@foodfluence/shared';
import { getFileTypeDisplayText } from '../../../utils/contentUploadUtils';
import { ff } from '../../../theme';

interface ContentUploadAreaProps {
  contentRequirement?: ContentRequirement;
  index?: number;
  isDragActive?: boolean;
  onClick?: () => void;
}

export const ContentUploadArea: React.FC<ContentUploadAreaProps> = ({
  contentRequirement,
  index,
  isDragActive,
  onClick,
}) => {

  const isCarousel = contentRequirement && 'items' in contentRequirement;

  return (
    <Box
      as="button"
      type="button"
      w="100%"
      textAlign="center"
      cursor="pointer"
      px={4}
      py="28px"
      minH="132px"
      border="1.5px dashed"
      borderColor={isDragActive ? ff.ink : ff.border}
      borderRadius="20px"
      bg={isDragActive ? ff.limeSurface : 'white'}
      _hover={{ borderColor: ff.ink, bg: ff.grey }}
      transition="all 0.2s"
      onClick={onClick}
    >
      <VStack spacing="8px">
        <Icon
          as={FiUpload}
          boxSize="26px"
          strokeWidth={2.2}
          color={ff.ink}
          aria-hidden
        />
        <Text fontSize="15px" fontWeight={600} color={ff.ink} lineHeight="normal">
          {isDragActive
            ? "Drop your file here"
            : isCarousel
              ? `Upload ${contentRequirement?.type} ${index! + 1}`
              : "Tap to select or drag your file here"
          }
        </Text>
        <Text fontSize="13px" color={ff.text2} lineHeight="normal">
          Supports: {getFileTypeDisplayText(contentRequirement)}
        </Text>
      </VStack>
    </Box>
  );
};
